import english from './english'

export default {
  en: english,
}
